<template>
  <div>
    <pageTable/>
  </div>
</template>

<script>
import PageTable from './components/table';
export default {
  name: 'tc-expense',
  components: {
    PageTable,
  },
}
</script>